import { jsx as g } from "react/jsx-runtime";
const h = "https://images.insighthealth.ai/insight-logos/new/insight-health-logo-black.svg", a = "https://images.insighthealth.ai/insight-logos/new/insight-health-logo-icon.svg", e = ({
  compact: s = !1,
  alt: t = "Insight Health Logo",
  ...i
}) => {
  const o = {
    ...i,
    alt: t,
    src: s ? a : h
  };
  return /* @__PURE__ */ g("img", { ...o });
};
export {
  h as L,
  a,
  e as b
};
